"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@mui/material/styles");
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const RadioGroup_1 = __importDefault(require("@mui/material/RadioGroup"));
const styled_components_1 = __importDefault(require("styled-components"));
const Radio_1 = __importDefault(require("../Radio"));
const StyledRadioGroup = (0, styled_components_1.default)(RadioGroup_1.default) `
  .MuiFormControlLabel-labelPlacementBottom {
    margin: ${({ row }) => (row ? "0 8px" : 0)};

    &:first-of-type {
      margin-left: 0;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }

  .MuiRadio-root {
    color: ${({ theme }) => theme.palette.gray[40]};
  }

  .MuiFormControlLabel-label {
    color: ${({ theme }) => theme.palette.gray[60]};
    font-size: 14px;
  }
`;
const RadioGroup = ({ options, labelPlacement, iconSize = 16, ...rest }) => {
    const theme = (0, styles_1.useTheme)();
    const iconProps = { size: iconSize };
    const uncheckedIconProps = { ...iconProps, color: theme.palette.gray[40] };
    return ((0, jsx_runtime_1.jsx)(StyledRadioGroup, { ...rest, children: options.map((option) => ((0, react_1.createElement)(FormControlLabel_1.default, { ...option, key: `${option.label}-${option.value}`, control: (0, jsx_runtime_1.jsx)(Radio_1.default, { checkedIconProps: iconProps, color: "primary", uncheckedIconProps: uncheckedIconProps }), labelPlacement: labelPlacement }))) }));
};
exports.default = RadioGroup;
//# sourceMappingURL=index.js.map